import * as TYPES from "./types";
import {isEmptyObject} from "@/services/services";

const pageInitFilter = {
    limit: 25,
    offset: 0
};

export default {
    [TYPES.SET_FILTER](state: any, data: any) {
        state.default_filter = true;
        state.filter = isEmptyObject(data.filter)
            ? { ...pageInitFilter }
            : data.filter;
    },
    [TYPES.CHANGE_FILTER](state: any, data: any) {
        state.default_filter = false;
        const filter = {
            ...state.filter,
            offset: 0,
            ...data
        };
        if (!filter.network) {
            delete filter.network;
        }
        if (!filter.is_public) {
            delete filter.is_public;
        }
        if (!filter.is_banned) {
            delete filter.is_banned;
        }
        if (!filter.is_banned) {
            delete filter.is_banned;
        }
        if (!filter.is_active) {
            delete filter.is_active;
        }
        if (!filter.is_expiring_within_a_week) {
            delete filter.is_expiring_within_a_week;
        }
        if (!filter.is_healthy) {
            delete filter.is_healthy;
        }
        state.filter = {...filter};
    }
};
